module.exports = __webpack_public_path__ + "img/EU-flag.56b0abeb.jpg";